import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";

import CardBody from "components/Card/CardBody.js";
import styles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.js";
import lazada from "assets/img/lazada.jpg";
import shopee from "assets/img/shpee.jpg";
import line from "assets/img/line.jpg";
const useStyles = makeStyles(styles);

export default function SectionCardPays() {
  const classes = useStyles();
  React.useEffect(() => {
    if (window) {
      window.addEventListener("resize", addStylesForRotatingCards);
    }
    addStylesForRotatingCards();
    return function cleanup() {
      if (window) {
        window.removeEventListener("resize", addStylesForRotatingCards);
      }
    };
  });
  const addStylesForRotatingCards = () => {
    var rotatingCards = document.getElementsByClassName(classes.cardRotate);
    for (let i = 0; i < rotatingCards.length; i++) {
      var rotatingCard = rotatingCards[i];
      var cardFront = rotatingCard.getElementsByClassName(classes.front)[0];
      var cardBack = rotatingCard.getElementsByClassName(classes.back)[0];
      cardFront.style.height = "unset";
      cardFront.style.width = "unset";
      cardBack.style.height = "unset";
      cardBack.style.width = "unset";
      var rotatingWrapper = rotatingCard.parentElement;
      var cardWidth = rotatingCard.parentElement.offsetWidth;
      var cardHeight = rotatingCard.children[0].children[0].offsetHeight;
      rotatingWrapper.style.height = cardHeight + "px";
      rotatingWrapper.style["margin-bottom"] = 30 + "px";
      cardFront.style.height = "unset";
      cardFront.style.width = "unset";
      cardBack.style.height = "unset";
      cardBack.style.width = "unset";
      cardFront.style.height = cardHeight + 35 + "px";
      cardFront.style.width = cardWidth + "px";
      cardBack.style.height = cardHeight + 35 + "px";
      cardBack.style.width = cardWidth + "px";
    }
  };
  return (
    <div className="cd-section" id="cards">
      <div>
        {/* MORPHING CARDS START */}
        <div id="morphingCards" className="cd-section">
          <div className={classes.container}>
            <GridContainer style={{ padding: 30 }}>
              <GridItem>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  <h2
                    className={classes.description}
                    style={{
                      color: "#3C4858",
                      marginBottom: 50,
                      fontFamily: "Kanit",
                      fontWeight: "bold",
                    }}
                  >
                    ช่องทางการสั่งซื้อ
                  </h2>
                </div>
              </GridItem>
              <GridItem xs={12} sm={6} md={6} lg={4}>
                <div className={classes.rotatingCardContainer}>
                  <Card className={classes.cardRotate}>
                    <a href="https://www.lazada.co.th/shop/mercurytshirt/?spm=a2o4m.pdp_revamp.seller.1.48d57e40IRdOjf&itemId=297972691&channelSource=pdp">
                      <div className={classes.front}>
                        <CardBody
                          className={classes.cardBodyRotate}
                          style={{
                            backgroundColor: "#0F156D",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div style={{ width: 250, height: 164 }}>
                            <img
                              src={lazada}
                              style={{ maxWidth: "100%" }}
                              alt="เสื้อยืด lazada"
                            />
                          </div>
                        </CardBody>
                      </div>
                      <div className={classes.back}>
                        <CardBody className={classes.cardBodyRotate}>
                          <h5 className={classes.cardTitle}>LAZADA</h5>
                          <p className={classes.cardDescription}>
                            ช่องทางสั่งซื้อสินค้าที่ง่ายและสะดวก
                            แถมมีบริการเก็บชำระเงินปลายทาง
                            สะดวกแอพลาซาด้าหรือช็อปปี้ เลือกได้
                          </p>
                        </CardBody>
                      </div>
                    </a>
                  </Card>
                </div>
              </GridItem>
              <GridItem xs={12} sm={6} md={6} lg={4}>
                <div className={classes.rotatingCardContainer}>
                  <Card className={classes.cardRotate}>
                    <a href="https://shopee.co.th/shop/226766160/search">
                      <div className={classes.front}>
                        <CardBody
                          className={classes.cardBodyRotate}
                          style={{
                            backgroundColor: "#ee4e2c",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div style={{ width: 250, height: 164 }}>
                            <img
                              src={shopee}
                              style={{ maxWidth: "100%" }}
                              alt="เสื้อยืด shopee"
                            />
                          </div>
                        </CardBody>
                      </div>
                      <div className={classes.back}>
                        <CardBody className={classes.cardBodyRotate}>
                          <h5 className={classes.cardTitle}>SHOPEE</h5>
                          <p className={classes.cardDescription}>
                            ช่องทางสั่งซื้อสินค้าที่ง่ายและสะดวก
                            แถมมีบริการเก็บชำระเงินปลายทาง
                            สะดวกแอพลาซาด้าหรือช็อปปี้ เลือกได้
                          </p>
                        </CardBody>
                      </div>
                    </a>
                  </Card>
                </div>
              </GridItem>
              <GridItem xs={12} sm={6} md={6} lg={4}>
                <div className={classes.rotatingCardContainer}>
                  <Card className={classes.cardRotate}>
                    <a href="https://page.line.me/mercurytshirt.com?openQrModal=true">
                      <div className={classes.front}>
                        <CardBody
                          className={classes.cardBodyRotate}
                          style={{
                            backgroundColor: "#00c402",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div style={{ width: 250, height: 164 }}>
                            <img
                              src={line}
                              style={{ maxWidth: "100%" }}
                              alt="สั่งซื้อเสื้อยืดผ่านไลน์"
                            />
                          </div>
                        </CardBody>
                      </div>
                      <div className={classes.back}>
                        <CardBody className={classes.cardBodyRotate}>
                          <h5 className={classes.cardTitle}>Line@</h5>
                          <p className={classes.cardDescription}>
                            สนใจสั้งซื้อสินค้าด่วนตั้งแต่ 20
                            ตัวขึ้นไปแอดไลน์มาได้เลยค่ะ มีเจ้าหน้าที่คอยดูแล 24
                            ชั่วโมง
                          </p>
                        </CardBody>
                      </div>
                    </a>
                  </Card>
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </div>
        {/* MORPHING CARDS END */}
      </div>
    </div>
  );
}
